import { ShopAdapterModel, localhost ,TryWestClinic29, OrthoCentre, OrthoCentreTest, OfficeDemo} from "./ShopAdapter/ShopAdapterModel";


export class AppSettings {
  public static isShoppingCart = true;
  public static showDcotorIconInBooking = true;
  public static needInputEhCardVoucherWhenPay = true; //Depercated , delete in next commit
  public static LockEditItemCateIDInBill:string[] = ['30']; //lock itemCateID edit action (change/delete) in billing page
  public static HideItemCateOnMenuInBill:string[] = ['30']; // hide itemCate on add item menu in billing

  public static readonly dateFormat = "dd/MM/yyyy";
  public static readonly timeFormat = "HH:mm";
  public static readonly PRE_PAY_ITEM_ID = "P777";
  public static readonly PHYSIO_EMP_ID = "PH";

  // public static shopAdapter: ShopAdapterModel = new localhost;
  public static shopAdapter: ShopAdapterModel = new OfficeDemo;
  // public static shopAdapter: ShopAdapterModel = new TryWestClinic29;
  // public static shopAdapter: ShopAdapterModel = new OrthoCentre;
  // public static shopAdapter: ShopAdapterModel = new OrthoCentreTest;
  public static BaseURI = AppSettings.shopAdapter.BaseURI;

  public static PATH_MAIN = "/main";

  public static PATH_EDIT = "/edit";
  public static PATH_NEW = "/new";

  public static Path_login = "/login";

  public static Path_tShop = AppSettings.PATH_MAIN + "/shop";
  public static Path_bed = AppSettings.PATH_MAIN + "/bed";

  public static Path_tShopBldg = AppSettings.PATH_MAIN + "/shopbldg";
  public static Path_tPatientType = AppSettings.PATH_MAIN + "/patient_type";
  public static Path_tPatient = AppSettings.PATH_MAIN + "/patient";

  public static Path_EmployeeLeave = AppSettings.PATH_MAIN + "/employeeLeave";
  public static Path_LoginManagement =
    AppSettings.PATH_MAIN + "/loginManagement";

  public static Path_tMedicine = AppSettings.PATH_MAIN + "/medicine";

  public static Path_tMedicineMainTab = AppSettings.PATH_MAIN + "/medicinemain";

  public static Path_tEmployee = AppSettings.PATH_MAIN + "/employee";

  public static Path_tVendor = AppSettings.PATH_MAIN + "/vendor";

  public static Path_tBookAux = AppSettings.PATH_MAIN + "/bookaux";
  public static Path_Booking = AppSettings.PATH_MAIN + "/booking";

  public static Path_tChangeAcct = AppSettings.PATH_MAIN + "/changeacct";

  public static Path_SearchtChangeAcct =
    AppSettings.PATH_MAIN + "/searchChangeAcct";
  public static Path_tItemCate = AppSettings.PATH_MAIN + "/itemcate";
  public static Path_tItem = AppSettings.PATH_MAIN + "/item";

  public static Path_Unit = "/unit";
  public static Path_Cost = "/cost";

  public static Path_tPackage = AppSettings.PATH_MAIN + "/package";

  public static Path_pItem = "/item";
  public static Path_pNonItem = "/nonitem";

  public static Path_tPriceBook = AppSettings.PATH_MAIN + "/pricebook";

  public static Path_tPayment = AppSettings.PATH_MAIN + "/payment";

  public static Path_tConsultHead_Waiting =
    AppSettings.PATH_MAIN + "/WaitingConsult";

  public static Path_tConsultHead_OnConsult =
    AppSettings.PATH_MAIN + "/OnConsult";
  public static Path_BookingArrive = AppSettings.PATH_MAIN + "/bookingArrive";

  public static Path_Outstanding = AppSettings.PATH_MAIN + "/outstanding";
  public static Path_BillPay = AppSettings.PATH_MAIN + "/billpay";

  public static Path_BillPayWalkIn = AppSettings.PATH_MAIN + "/billpayWalkIn";

  public static Path_consultDiag = "/diag";
  public static Path_consultService = "/service";
  public static Path_consultCert = "/cert";
  public static tFee = "/tFee";
  public static Path_printCert = "/print";

  public static Path_VoidVoucher = AppSettings.PATH_MAIN + "/VoidVoucher";
  public static Path_PatientHistory = AppSettings.PATH_MAIN + "/PatientHistory";

  public static Path_PatientMasterHistory = "/his";

  public static Path_Stock = "/Stock";
  // public static Path_Inbound = "/Inbound";
  // public static Path_Outbound = "/Outbound";

  public static Path_GRN = AppSettings.PATH_MAIN + "/grn";
  public static Path_changePay = AppSettings.PATH_MAIN + "/ChangePay";

  public static Path_Inbound = AppSettings.PATH_MAIN + "/Inbound";
  public static Path_Outbound = AppSettings.PATH_MAIN + "/Outbound";
  public static Path_prescription = AppSettings.PATH_MAIN + "/Prescription";
  public static Path_copyPrescription = AppSettings.PATH_MAIN + "/copyPrescription";
  public static Path_Report = AppSettings.PATH_MAIN + "/report";

  public static Path_Acc = AppSettings.PATH_MAIN + "/accounting";

  public static Path_DayEndReport = "/DayEndReport";
  public static Path_DayEndDetailsReport = "/DayEndDetailsReport";

  public static Path_PackageRemainderReport = "/PackageReminderReport";

  public static Path_PrescriptionList =
    AppSettings.PATH_MAIN + "/PrescriptionList";

    public static Path_PrescriptionPickList =
    AppSettings.PATH_MAIN + "/PrescriptionPickList";

    public static Path_Xray =
    AppSettings.PATH_MAIN + "/Xray";

    public static Path_Physio =
    AppSettings.PATH_MAIN + "/Physio";
  public static Path_LoginUser = AppSettings.PATH_MAIN + "/loginUserMaster";

  public static Path_UserPermission = AppSettings.PATH_MAIN + "/rolePermission";

  public static Path_Print = AppSettings.PATH_MAIN + "/print";
  public static Path_OutBoundReceipt = "/OutBoundReceipt";
  public static Path_InBoundReceipt = "/InBoundReceipt";

  public static Path_StockMovementReport = "/StockMovementReport";
  public static Path_StockOnHandReport = "/StockOnHandReport";

  public static Path_VoidVoucherBackDay = "/backday";

  public static Path_BookingReviewReport = "/BookingReviewReport";

  public static Path_EmployeeServiceReport = "/EmployeeServiceReport";
  public static Path_EmployeeServiceReport2 = "/EmployeeServiceReport2";
  public static Path_CustomMasterReport = "/CustomMasterReport";
  public static Path_AnalysisReport = "/AnalysisReport";

  public static Path_ChangeAccountReport = "/ChangeAccountReport";

  public static Path_VoidBillReport = "/VoidBillReport";

  public static Path_MonthSalesReport = "/MonthSalesReport";

  public static Path_SalesSummaryByDayReport = "/SalesSummaryByDayReport";

  public static Path_PatientSourceReport = "/PatientSourceReport";

  public static Path_Warehouse = AppSettings.PATH_MAIN + "/warehouse";

  public static Path_ConsultAssignRecords = "/ConsultAssignRecords";

  public static Path_ChartAccMaster = "/chartAcc";

  public static Path_ChartAccMonthEndPosting =
    AppSettings.PATH_MAIN + "/chartaccMonthEndPosting";

  public static Path_AccPostingSetup =
    AppSettings.PATH_MAIN + "/accPostingSetup";

  public static Path_ReportControl = AppSettings.PATH_MAIN + "/ReportControl";
  public static Path_Journal = AppSettings.PATH_MAIN + "/journal";
  public static Path_JournalEdit = AppSettings.PATH_MAIN + "/journal/edit";
  public static Path_Questionnaire = AppSettings.PATH_MAIN + "/Questionnaire";

  public static Path_PatientRecordsReport = "/PatientRecordsReport";

  public static Path_Currency = "/currency";
  public static Path_Rate = "/rate";
  public static Path_GLSetting = "/glSetting";
  public static Path_AccPeriod = "/accPeriod";
  public static Path_AccMonthEndClosing = "/accMonthEndClosing";

  public static Path_Analysis = "/analysis";
  public static Path_GeneralLedgerReport = "/GeneralLedgerReport";
  public static Path_TrialBalanceReport = "/TrialBalanceReport";
  public static Path_ProfitAndLossReport = "/ProfitAndLossReport";
  public static Path_BalanceSheetReport = "/BalanceSheetReport";
  public static Path_PaymentLedgerReport = "/PaymentLedgerReport";
  public static Path_MonthSalesReport2 = "/MonthSalesReport2";
  public static Path_DrugSpendingReport = "/DrugSpendingReport";

  public static Path_itemCateSummary="/itemCateSummaryReport"

  public static Path_MaterialOrderReport = "/MaterialOrderReport";
  public static Path_YearEnd = "/yearEnd";
  public static Path_MedicineType = AppSettings.PATH_MAIN +"/medicineTypeMaster";
  public static Path_BatchNumber = AppSettings.PATH_MAIN +"/batchNumberEnquiry";
  public static Path_tPurchaseOrder = AppSettings.PATH_MAIN +"/purchaseOrder";
  public static Path_ImportExportMaster = AppSettings.PATH_MAIN + '/ImportExportMaster';

  public static Path_historyByDate=AppSettings.PATH_MAIN + '/historyByDate';
  public static Path_materialCatMaster=AppSettings.PATH_MAIN + '/materialCatMaster';
  public static Path_dishesMaster=AppSettings.PATH_MAIN + '/dishesMaster';
  public static Path_materialMaster=AppSettings.PATH_MAIN + '/materialMaster';
  public static Path_materialList=AppSettings.PATH_MAIN + '/materialList';
  public static Path_dishesPlan=AppSettings.PATH_MAIN + '/dishesPlan';

  public static Path_MonthSalesReportNewCases = "/MonthSalesReportNewCases";
  public static Path_MonthSalesAnalysisReport = "/MonthSalesAnalysisReport";

  public static Path_GrnReport = "/GrnReport";

}

export class AssetsPath {
  private static p = AppSettings.shopAdapter.imagePath + "/assets";
  static readonly configF = AssetsPath.p + '/config';
  public  static cssF = AssetsPath.p + '/css';
  public  static fontF = AssetsPath.p + '/font';
  public  static imgF = AssetsPath.p + '/img';

  public static imgShopLogo = `${AssetsPath.imgF}/print/doc_logo.png`;

  public path(value:string|string[]) : string {
    return '';
  }

}
